import {Component, OnInit, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService} from "ngx-bootstrap";
import {FormBuilder, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {NotifierService} from "angular-notifier";
import {UserService} from "../../../service/user.service";
import {ImageCroppedEvent} from "ngx-image-cropper";
import { DragulaService } from 'ng2-dragula';

@Component({
  selector: 'app-itenary-manage',
  templateUrl: './itenary-manage.component.html',
  styleUrls: ['./itenary-manage.component.scss']
})
export class ItenaryManageComponent implements OnInit {

  isLoading: any;
  packForm: any;
  packages: any;
  modalRef: BsModalRef;
  @ViewChild("errorModal", {static: true}) errorModal;
  @ViewChild("addModal", {static: true}) addModal;
  @ViewChild("upModal", {static: true}) upModal;
  deleteID: any;
  itenary: any;
  itDetail: Array<any> = [];
  imageChangedEvent: any;
  showCropper: any;
  croppedImage: any = '';
  // showCropper = false;
  imageCropper: any;
  isloading: boolean;
  pacID: any;
  itenarys: any;
  editIt: any;
  catgorys: any;
  type: any;
  packID: any;
  desc: Array<any> = [];
  removeEvt: any;
  page: any;
  totalRec: any;
  isup: boolean;
  upid: any;
  pacname: any;

  constructor(private formBuilder: FormBuilder, private route: Router, private notifier: NotifierService,
              private userService: UserService, private modalService: BsModalService,private dragulaService: DragulaService) {

    this.packForm = this.formBuilder.group({
      title: ["", [Validators.required]],
      desc: [],
    });
    this.itForm = this.formBuilder.group({
      pName: ["", [Validators.required]],
      categoryId: ["", [Validators.required]],
      type: ["", [Validators.required]],

    });

    this.dragulaService.createGroup("VAMPIRES", {
      // ...
    });

    this.dragulaService.dropModel("VAMPIRES").subscribe(args => {
      console.log(args);
    });
  }

  ngOnInit() {
    this.packID=null;
    this.getallPackages(1);
    this.getAllCategory();
    this.getAllType();
    this.pacname ='Package Name'
  }


  getallPackages(pageIndex) {
    let req = {}

    let size = 10;
    let page = pageIndex - 1;
    this.userService.packageSearch(req,size,page).subscribe(
      res => {
        if (res.responseCode == 200) {
          this.packages =res['data']['content'];
          this.page = res['data']['number'];
          this.totalRec = res['data']['totalElements'];
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  searchPackages(pageIndex) {
    let req = {
      packageName: this.itForm.controls.pName.value,
      type: this.itForm.controls.type.value,
      categoryId: this.itForm.controls.categoryId.value,
    }
    let size = 10;
    let page = pageIndex - 1;
    this.userService.packageSearch(req,size,page).subscribe(
      res => {
        if (res.responseCode == 200) {
          this.packages =res['data']['content'];
          this.page = res['data']['number'];
          this.totalRec = res['data']['totalElements'];
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  packageDelete(errorModal, id: any) {
    this.deleteID = id;
    this.modalRef = this.modalService.show(errorModal, {class: 'modal-dialog-centered'});
  }

  packageUpdate(id: any) {

  }

  createModal() {

  }

  createPackage() {

  }

  declineDelete() {
    this.modalRef.hide();
  }


  confirmDelete() {
    this.userService.deletePackage(this.deleteID).subscribe(
      res => {
        if (res.responseCode === 200) {
          this.modalRef.hide();
          this.notifier.notify('success', res.responseDesc);
          this.getallPackages(this.currentPage);
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  update(pac: any) {
    this.upModal.show()
    this.itenarys = pac
    localStorage.setItem('packUpdate', 'true');
    localStorage.setItem('packUpdateData', JSON.stringify(pac));
  }

  add() {
    this.packForm.reset();
    this.itForm.reset();
    this.isup=false;
    this.addModal.show();
  }

  remove(description: string | (() => string)) {

  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    console.log(JSON.stringify(event.target.files + "evt"))
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.file;
    console.log(JSON.stringify(event.file))
  }

  imageLoaded() {
    this.showCropper = true;
  }

  rotateLeft() {
    this.imageCropper.rotateLeft();
  }

  rotateRight() {
    this.imageCropper.rotateRight();
  }

  flipHorizontal() {
    this.imageCropper.flipHorizontal();
  }

  flipVertical() {
    this.imageCropper.flipVertical();
  }

  detailadd() {
    this.itDetail.push({
      description: this.packForm.controls.desc.value,
    })
  }

  descadd() {
    this.desc.push({
      description: this.packForm.controls.desc.value,
    })
  }

  removeExclue(des) {
    for (let i = 0; i < this.itDetail.length; ++i) {
      if (this.itDetail[i].description === des) {
        this.itDetail.splice(i, 1);
      }
    }
  }

  removeDesc(des) {
    for (let i = 0; i < this.desc.length; ++i) {
      if (this.desc[i].description === des) {
        this.desc.splice(i, 1);
      }
    }
  }

  upload(id) {
    this.userService.uploadItenaryImg(this.files[0], id).subscribe(
      data => {
        if (data.responseCode == 200) {
          this.notifier.notify('success', data.responseDesc);
        } else {
          this.notifier.notify('danger', 'Somthing went wrong faild to upload image.');
        }
      });
  }

  createItenary() {
    this.isloading = true;
    let req = {
      description: this.packForm.controls.title.value,
      packageIternaryDetailsDTOList: this.desc,
      packageId: this.packID,
    }
    this.userService.createItenary(req).subscribe(
      res => {
        if (res.responseCode == 200) {
          this.upload(res.data);
          this.isloading = false;
          this.notifier.notify('success', res.responseDesc);
          this.packForm.reset();
          this.onRemove(this.removeEvt)
          this.addModal.hide();
          this.desc =[];
        } else {
          this.isloading = false;
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  updateItenary() {
    this.isloading = true;
    let req = {
      id :this.upid,
      description: this.packForm.controls.title.value,
      packageIternaryDetailsDTOList: this.desc,
      packageId: this.packID,
    }
    this.userService.createItenary(req).subscribe(
      res => {
        if (res.responseCode == 200) {
          this.upload(res.data);
          this.isloading = false;
          this.notifier.notify('success', res.responseDesc);
          this.packForm.reset();
          this.onRemove(this.removeEvt)
          this.addModal.hide();
          this.desc =[];
        } else {
          this.isloading = false;
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }
  files: File[] = [];
  itForm: any;
  currentPage: any;
  vamps: any;

  onSelect(event) {
    console.log(event);
    this.files.push(...event.addedFiles);
  }

  onRemove(event) {
    this.removeEvt=event
    this.files.splice(this.files.indexOf(event), 1);
  }

  itenaryClick(ex: any) {
    this.editIt = ex;
    this.upModal.hide();
    this.addModal.show();

    this.itDetail = ex.packageIternaryDetailsList;

  }

  tblClick(description) {
    this.packForm.controls['desc'].setValue(description);
  }

  packSelect(id,itenary,pac) {
    this.packID=id;
    this.itDetail =itenary;
    this.pacname = pac.packageName;

  }

  getAllCategory() {
    this.userService.getAllCategory().subscribe(
      res => {
        if (res.responseCode == 200) {
          this.catgorys = res.data;
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  getAllType() {
    this.userService.getAllType().subscribe(
      res => {
        if (res.responseCode == 200) {
          this.type = res.data;
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  reset() {
    this.itForm.reset();
  }

  up(i) {
    this.upid = i.id;
    this.isup=true;
    this.addModal.show();
    console.log(i);
    this.packForm.controls['title'].setValue(i.description);
    this.desc=i.packageIternaryDetailsList;
  }

  dlt(i: any) {
    this.userService.deleteItenary(i.id).subscribe(
      res => {
        if (res.responseCode == 200) {
          this.notifier.notify('success', res.responseDesc);
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  vamp() {
    console.log(this.itDetail);
    console.log(this.packID);
    this.userService.arrangelist(this.packID,this.itDetail).subscribe(
      res => {
        if (res.responseCode == 200) {
          this.type = res.data;
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }
}
